import {ID, Resource} from 'simpli-web-sdk'
import DeliverySatisfactionSurveyHistoryResponseSchema from '@/schema/DeliverySatisfactionSurveyHistoryResponse.schema'
import Carga from '@/model/resource/Carga'

export default class DeliverySatisfactionSurveyHistoryResponse extends Resource {

  readonly $name: string = 'DeliverySatisfactionSurveyHistoryResponse'
  readonly $endpoint: string = '/user/indicador/historico-pesquisa-satisfacao'

  get $id() {
    return this.id
  }
  set $id(val: ID) {
    this.id = val
  }

  get $schema() {
    return DeliverySatisfactionSurveyHistoryResponseSchema(this)
  }

  id: ID = 0
  imgUrl: string | null = null
  notaPergunta1: string | null  = null
  notaPergunta2: string | null  = null
  carga: Carga | null  = null
  data: string | null = null
  pergunta1: string | null = null
  pergunta2: string | null = null
  documentoRecebedor: string | null = null
  nomeRecebedor: string | null = null
  razaoSocial: string | null = null
  cpfMotorista: string | null = null
}
